import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  NbButtonModule,
  NbContextMenuModule,
  NbIconModule,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbToastrService,
} from '@nebular/theme';
import { Subject, filter, takeUntil } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { mensagemDeErro } from '../../utils/mensagem-erro';

const ITEM_TROCAR_SENHA = 'Trocar senha';

@Component({
  selector: 'app-header-externo',
  standalone: true,
  imports: [CommonModule, NbButtonModule, NbContextMenuModule, NbIconModule],
  templateUrl: './header-externo.component.html',
  styleUrl: './header-externo.component.scss',
})
export class HeaderExternoComponent implements OnInit, OnDestroy {
  nomeUsuario: string | null = null;

  /**
   * O que o botão de conta abre. "Minhas turmas" aponta para a mesma rota do item de mesmo
   * nome na barra lateral, e aparece sob a mesma condição: só catequista tem turma vinculada.
   */
  menuUsuario: NbMenuItem[] = [{ title: 'Sair', icon: 'log-out-outline' }];

  private readonly destruido = new Subject<void>();

  constructor(
    private router: Router,
    private auth: AuthService,
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private toastr: NbToastrService,
  ) {}

  ngOnInit(): void {
    this.nomeUsuario = this.auth.getNome();
    this.montarMenu();
    this.auth.perfil$.pipe(takeUntil(this.destruido)).subscribe(() => this.montarMenu());

    this.menuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'menu-usuario'),
        takeUntil(this.destruido),
      )
      .subscribe(({ item }) => {
        if (item.title === 'Sair') {
          this.sair();
        } else if (item.title === ITEM_TROCAR_SENHA) {
          this.pedirTrocaDeSenha();
        }
      });
  }

  private montarMenu(): void {
    const itens: NbMenuItem[] = [
      { title: 'Meus dados', icon: 'person-outline', link: '/meus-dados' },
    ];
    if (this.auth.podeVerMinhasTurmasMenu()) {
      itens.push({ title: 'Minhas turmas', icon: 'briefcase-outline', link: '/minhas-turmas' });
    }
    itens.push({ title: ITEM_TROCAR_SENHA, icon: 'lock-outline' });
    itens.push({ title: 'Sair', icon: 'log-out-outline' });
    this.menuUsuario = itens;
  }

  ngOnDestroy(): void {
    this.destruido.next();
    this.destruido.complete();
  }

  toggleMenu(): void {
    // `false` = alterna entre plena e recolhida. Com `true` o Nebular alternaria para o
    // estado compacto, a faixa de ícones que NAV-03 proíbe.
    this.sidebarService.toggle(false, 'menu-sidebar');
  }

  navigateHome(event: Event): boolean {
    event.preventDefault();
    this.router.navigateByUrl('/dashboard');
    return false;
  }

  /**
   * Não há formulário de senha aqui: a API manda um e-mail com o link, e a página da troca é do
   * servidor de autenticação. O acesso continua até a troca; concluída, o token atual é
   * revogado e o próximo `401` traz de volta ao login (`AUTH-06`).
   */
  pedirTrocaDeSenha(): void {
    this.auth.trocarSenha().subscribe({
      next: (res) =>
        this.toastr.success(
          res?.mensagem?.trim() || 'Enviamos um e-mail com o link para trocar a senha.',
          'Trocar senha',
        ),
      error: (err) =>
        this.toastr.danger(mensagemDeErro(err, 'Não foi possível pedir a troca de senha.'), 'Trocar senha'),
    });
  }

  sair(): void {
    this.auth.logout();
  }
}
